import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * 页面头部组件
 * 显示页面标题，并提供返回功能和自定义右侧内容
 * @param {Object|string} title - 页面标题，可以是字符串或JSX
 * @param {boolean} showBack - 是否显示返回按钮
 * @param {string} className - 附加的CSS类名
 * @param {JSX.Element} rightContent - 右侧自定义内容
 * @returns {JSX.Element} 头部组件
 */
function Header({ title, showBack = true, className = '', rightContent = null }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className={`bg-gradient-to-r from-primary-dark via-primary to-primary-light text-white py-3 px-4 shadow-md ${className}`}>
      <div className="flex items-center justify-between">
        {showBack ? (
          <button 
            onClick={handleBack} 
            className="p-1.5 rounded-full hover:bg-white/10 transition-colors flex items-center justify-center"
            aria-label="返回"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        ) : (
          <div className="w-8"></div>
        )}
        <div className="text-center flex-1 mx-2">{title}</div>
        {rightContent ? rightContent : <div className="w-8"></div>}
      </div>
    </div>
  );
}

export default Header; 